const loadingReduce = (action, state) => {
  const newState = { ...state };
  newState["externalProjectsList"]["loading"] = action.payload;
  return newState;
};

const setList = (action, state) => {
  const { items, countsByType } = action.payload;

  return {
    ...state,
    externalProjectsList: {
      ...state.externalProjectsList,
      result: items.items,
    },
    currentPagingInfo: {
      pageIndex: items.pageIndex,
      pageSize: items.pageSize,
      totalCount: items.totalCount,
      totalPages: items.totalPages,
      hasPreviousPage: items.hasPreviousPage,
      hasNextPage: items.hasNextPage,
    },
    // Tab counts are only refreshed on the "Todos" tab so the active tab doesn't reset.
    completePagingInfo: action.isAllTypes
      ? countsByType
      : state.completePagingInfo,
  };
};

const setTypeSearch = (action, state) => ({
  ...state,
  [action.key]: action.payload,
});

const setTypeSearchType = (action, state) => ({
  ...state,
  currentTypeSearch: {
    ...state.currentTypeSearch,
    filterType: action.payload,
    filterValue: {
      ...state.currentTypeSearch.filterValue,
      pageNumber: 1,
    },
  },
});

const setTypeSearchPage = (action, state) => ({
  ...state,
  currentTypeSearch: {
    ...state.currentTypeSearch,
    filterValue: {
      ...state.currentTypeSearch.filterValue,
      pageNumber: action.payload,
    },
  },
});

const setClearPagingInfo = (action, state) => ({
  ...state,
  completePagingInfo: action.payload,
});

const setCurrentTerm = (action, state) => ({
  ...state,
  currentTerm: action.payload,
});

export default (state, action) => {
  let _state = {
    loading: () => loadingReduce(action, state),
    currentTerm: () => setCurrentTerm(action, state),
    list: () => setList(action, state),
    filter: () => setTypeSearch(action, state),
    filterType: () => setTypeSearchType(action, state),
    pageFilter: () => setTypeSearchPage(action, state),
    clearCompletePagingInfo: () => setClearPagingInfo(action, state),
  };
  return _state[action.action]();
};
